<template>
  <div>
    <div class="bg-kct-green h-0.5"></div>
    <div class="relative" >
      <img src="/images/main-banner-2.jpg" class="w-full h-full" />
      <div class="absolute bottom-1 md:bottom-2 left-5" ><img src="/images/made-in-malaysia.png" alt="" class="w-7 md:w-20 xl:w-32" /></div>
    </div>
    <div class="py-10 bg-gray-100 " >
      <div class="container" >
        <div class="rounded-md md:w-2/3 bg-opacity-90">
          <div class="px-4 py-4 text-left md:py-6">
            <h1 class="pb-3 text-3xl font-bold leading-tight md:text-4xl lg:text-5xl text-kct-green">
              OVER 40 YEARS OF MANUFACTURING EXCELLENCE
            </h1>
            <h1 class="text-base leading-tight text-gray-800 xl:text-lg">
              Your One-Stop Manufacturer Solutions The More Complex The
              Customization The More We Love It!
            </h1>
            <div class="pt-3">
              <a href="#element" v-if="!hideEnquiry" v-scroll-to="{ el: '#element', duration: 1500 }">
                <h1 class="w-48 py-2 text-center text-white bg-gray-800 lg:w-56 hover:opacity-100 opacity-90">
                  Enquire Us
                </h1>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
    
  
  <!-- <div>
    <div class="bg-kct-green h-0.5"></div>
    <div class="relative bg-center bg-no-repeat bg-cover" style="background-image: url('/images/main-banner-2.jpg')">
      <div class="container flex flex-wrap items-center h-[550px] lg:h-[600px] xl:h-[750px]">
        <div class="bg-gray-100 rounded-md md:w-2/3 bg-opacity-90">
          <div class="px-4 py-4 text-left md:py-6">
            <h1 class="pb-3 text-3xl font-bold leading-tight md:text-4xl lg:text-5xl text-kct-green">
              OVER 35 YEARS OF MANUFACTURING EXCELLENCE
            </h1>
            <h1 class="text-base leading-tight text-gray-800 xl:text-lg">
              Your One-Stop Manufacturer Solutions The More Complex The
              Customization The More We Love It!
            </h1>
            <img src="/images/made-in-malaysia.png" alt="" class="w-24 lg:w-32" />
            <div class="pt-3">
              <a href="#element" v-if="!hideEnquiry" v-scroll-to="{ el: '#element', duration: 1500 }">
                <h1 class="w-48 py-2 text-center text-white bg-gray-800 lg:w-56 hover:opacity-100 opacity-90">
                  Enquire Us
                </h1>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> -->
</template>

<script>
export default {
  props: {
    hideEnquiry: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style></style>